import moment from "moment";
import React from "react";
import { TCRBRecord } from "../../../../../redux/app/crb/@types";
import { TCRBK2 } from "../../../../../redux/app/crb/groups/crb-k";
import { commonUtils } from "../../../../../redux/_common";
import CRBTableRows from "../CRBTableRows";

type OwnProps = {
	crbRecord: TCRBRecord;
	isStrikedOff?: boolean;
	theme?: "light" | "dark";
};
type CRBK2PreviewProps = OwnProps;
function CRBK2Preview(props: CRBK2PreviewProps) {
	const crbRecord = props.crbRecord as TCRBK2;
	const operationDate = moment(crbRecord.selectedDate, "YYYY-MM-DD").format(
		"DD-MMM-YYYY"
	);

	function renderMain() {
		return (
			<CRBTableRows
				record={crbRecord}
				tableRows={[
					[operationDate, "K", "_", renderNLSResidue()],
					[null, null, "_", renderWaiver()],
					[null, null, "_", renderPAM()],
					[null, null, "_", renderDischargeRecording()],
					[null, null, "NOTE", crbRecord.remarks],
				]}
			/>
		);
	}

	function renderNLSResidue() {
		let nlsResidue = crbRecord.itemO3.nlsResidue;
		return (
			<h4 className="font-medium uppercase">
				{nlsResidue
					? `NLS residue or NLS cargo is transferred from cargo pumproom bilges or transferred to an incinerator [46 CFR 153.909(a)(11)] - ${nlsResidue}`
					: "----"}
			</h4>
		);
	}

	function renderWaiver() {
		let waiver = crbRecord.itemO3.waiverIssued;
		return (
			<h4 className="font-medium uppercase">
				{waiver
					? `A waiver is issue to the ship, ship owner, ship operator, or person in charge of the ship under 46 CFR 153.[46 CFR 153.(a)(12)] - ${waiver}`
					: "----"}
			</h4>
		);
	}

	function renderPAM() {
		let pam = crbRecord.itemO3.pamPrescribes;
		return (
			<h4 className="font-medium uppercase">
				{pam
					? `Except where the approved Procedure and Arrangements Manual prescribes a different procedure, the concentration of a Category A or X NLS residue is measured under 46 CFR 153.1120(a). [46 CFR 153.909(a)(13)] - ${pam}`
					: "----"}
			</h4>
		);
	}
	function renderDischargeRecording() {
		let dischargeRecording = crbRecord.itemO3.dischargeRecording;
		return (
			<h4 className="font-medium uppercase">
				{dischargeRecording
					? `Any discharge recording equipment required by 46 CFR 153.481(b)(2) fails.[46 CFR 153.909(a)(14)] - ${dischargeRecording}`
					: "----"}
			</h4>
		);
	}

	return renderMain();
}

export default CRBK2Preview;
